import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 18.75a6.96 6.96 0 0 1-6.07-3.5c-1.258-2.16-1.258-4.812 0-7A7.02 7.02 0 0 1 12 4.75c2.488 0 4.785 1.34 6.043 3.5 1.258 2.188 1.258 4.84 0 7A6.95 6.95 0 0 1 12 18.75m-1.094-4.812c-.383 0-.656.3-.656.656 0 .383.273.656.656.656h2.188a.65.65 0 0 0 .656-.656c0-.356-.3-.656-.656-.656h-.219V11.53c0-.355-.3-.656-.656-.656h-1.313c-.383 0-.656.3-.656.656 0 .383.273.656.656.656h.656v1.75zM12 8.25a.88.88 0 0 0-.875.875c0 .492.383.875.875.875a.88.88 0 0 0 .875-.875A.9.9 0 0 0 12 8.25"
    }, null, -1)
  ]))]))
}
export default { render: render }